import { useContext, useEffect, useState } from "react";
import "./loadingspinner.sass";
import { Ship } from "./ship-spinner/ship-spinner";
import { ReportingContext } from "../../pages/home/home";

const DEFAULTLOADINGTEXT = "";
const CUBEVARSIZENAME = "--cube--size";
const STANDARDSIZE = "80px";

export const SPINNINGOPTIONS = { SHIP: "SHIP", CUBE: "CUBE" };

export const LoadingScreen = ({ loading, loadingText, children, size, style }) => {
  const [additionalText] = useState(loadingText ? loadingText : DEFAULTLOADINGTEXT);
  const [cubeSize] = useState(size ? size : STANDARDSIZE);
  if (loading) {
    return (
      <div className="is-loading">
        <LoadingComponent text={additionalText} size={cubeSize} style={style} />
      </div>
    );
  } else {
    return children;
  }
};

export const LoadingComponent = ({ text, size, style }) => {
  return (
    <>
      <div className="loadingSpinner" style={style}>
        <SpinningComponentChooser size={size} text={text} />
        {/* <SpinningCube LeStyle={LeStyle} text={text} /> */}
      </div>
    </>
  );
};

const SpinningComponentChooser = ({ text, size }) => {
  const [counter, setCounter] = useState(2);
  const context = useContext(ReportingContext);
  let name = null;
  if (context) {
    name = context.getDesignComponentName();
  }
  useEffect(() => {
    setCounter(counter + 1);
  }, [name]);

  switch (name) {
    case null:
      return <SpinningCube text={text} size={size} />;
    case SPINNINGOPTIONS.SHIP:
      return <Ship />;
    case SPINNINGOPTIONS.CUBE:
      return <SpinningCube text={text} size={size} />;
    default:
      return <SpinningCube text={text} size={size} />;
  }
};

const SpinningCube = ({ style, text, size }) => {
  let LeStyle = style ? style : {};
  document.querySelector("body").style.setProperty(CUBEVARSIZENAME, size);
  return (
    <div className="loadingSpinner" style={LeStyle}>
      <div className="cube">
        <Cube />
      </div>
      <p>{text}</p>
    </div>
  );
};

const Cube = () => {
  return (
    <>
      {["front", "back", "right", "left", "top", "bottom"].map((face, idx) => {
        return (
          <div
            key={face + idx}
            className={`face ${face} ${["back", "bottom", "left"].includes(face) ? "non-front" : ""}`}
            style={{
              backgroundColor: "white",
              // border: "1px solid black",
              // backgroundImage: `url(${TableBackgroundGradientColorImage})`,
              background: "linear-gradient(to right, #7BB0FF, #3E66FB, #F1F6FE)",
            }}
          />
        );
      })}
    </>
  );
};
